module.exports = __webpack_public_path__ + "img/53.e45259d7.png";